import Main from './Main.vue'
import Lista from './components/ListaSolicitacoes'
import Visualizar from './components/VisualizarSolicitacao'
import Solicitar from './components/Solicitar'

export default [
  {
    path: '/solicitacoes-remocao',
    name: 'solicitacoes-remocao',
    component: Main,
    children: [
      {path: '/', component: Lista, name: 'solicitacoes-remocao'},
      {path: ':id', component: Visualizar, name: 'visualizar.solicitacao-remocao'},
      {path: '/solicitar', component: Solicitar, name: 'solicitar-remocao'}

    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/solicitacao-remocao/routes.js